import { css } from 'styled-components';
import { StyledTriggerButton } from '../../components/TriggerButton/TriggerButton.styles';

/** @class TooltipPopperMixin */
/** @method */
export var TooltipPopperMixin = /*#__PURE__*/css(["&,&", ",&", ":after{cursor:help;}"], StyledTriggerButton, StyledTriggerButton);